import diaporama from './components/diaporama';
import videoFrame from './components/video';

diaporama.init();
videoFrame.init();
